import { OnInitialize } from './index';

export const onInitialize: OnInitialize = async ({ actions }) => {
    actions.handleLogin();
};
